<template>
  <div class="groups-wrapper">
    <div class="header">
      <img class="logo" src="https://files.wondercv.com/App%20Icon@2x.png" alt="">
      <p class="slogan">{{ groupsInfo.slogan }}</p>
    </div>
    <div class="content">

      <ul class="tag-list">
        <li class="tag-item" :class="tagIndex === currentTagIndex ? 'active' : ''" v-for="(tagItem, tagIndex) in groupsInfo.group_infos" :key="tagIndex" @click="toggleTag(tagItem, tagIndex)">{{ tagItem.tag }}</li>
      </ul>

      <div class="qrcode-box">

        <img class="qrcode" :src="currentTagData.link" alt="">
        <p class="qrcode-desc">长按可以识别二维码加群</p>

        <div class="tag-desc">
          <span>“</span>
          <p>{{ currentTagData.description }}</p>
          <span>”</span>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import WNavbar from '@/components/global/w-navbar'
import community from "../../../api/api-list/community"

export default {
  data () {
    return {
      currentTagData: {},
      currentTagIndex: 0,
      groupsInfo: {
        title: null,
        slogan: null,
        group_infos: []
      }
    }
  },
  components: {
    WNavbar
  },
  created () {
    // 设置 页面标题
    this.getGroupsInfo()
  },
  methods: {
    toggleTag (data, i) {
      this.currentTagData = data
      this.currentTagIndex = i
    },
    // 获取 微信群配置
    async getGroupsInfo () {
      try {
        let res = await community.getGroupsInfo()
        if (res.code === 1000) {
          this.groupsInfo = res.data
          document.title = res.data.title
          this.currentTagData = res.data.group_infos[0]
        }
      } catch (error) {
        console.log('获取 微信群配置列表 错误：', error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .groups-wrapper {

    .header {
      display: flex;
      flex-direction: column;
      align-items: center;
      min-height: 163px;
      background: url('https://files.wondercv.com/m/groups/groups-bg.png') no-repeat;
      background-size: cover;
      background-position: center;

      .logo {
        width: 50px;
        margin-top: 34px;
        margin-bottom: 8px;
      }

      .slogan {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #404040;
        line-height: 1.6;
        padding: 0 20px;
        text-align: center;

      }

    }

    .content {
      padding: 22px 20px;

      .tag-list {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;

        .tag-item {
          display: inline-block;
          padding: 10px 12px;
          border-radius: 17px;
          border: 1px solid #EEEFF0;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #9C9C9C;
          line-height: 14px;

          &.active {
            color: #fff;
            border-color: #FF6644;
            background: #FF6644;
          }
        }
      }

      .qrcode-box {
        display: flex;
        flex-direction: column;
        align-items: center;

        .qrcode {
          width: 159px;
          height: 159px;
          margin: 20px auto 8px;
        }

        .qrcode-desc {
          display: block;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #9C9C9C;
          line-height: 17px;
        }

        .tag-desc {
          width: 100%;
          margin-top: 60px;

          >span {
            width: 100%;
            display: block;
            font-size: 25px;
            font-family: DFWaWaTC-W5, DFWaWaTC;
            font-weight: normal;
            color: #404040;
            line-height: 25px;

            &:last-of-type {
              text-align: right;
              margin-top: 14px;
            }
          }

          >p {
            padding: 0 16px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #404040;
            line-height: 17px;
          }

        }

      }

    }

  }
</style>
